import {
  FailModalGrooveTicket,
  SendApiRequest,
  SuccessModalGrooveTicket,
  getTargetInbox,
  useTicketState,
} from "./utils"
import React, { useEffect } from "react"
import { validateMailAddress } from "components/page-components/Signup-Forms/utils"

export const CreateGrooveTicket = ({ segment }) => {
  const {
    ticketState,
    setTicketState,
    datenschutzToggle,
    updateTicketSubject,
    updateMailAddress,
    updatePhoneNumber,
    updateCompanyName,
    updateTicketText,
  } = useTicketState()

  const targetInbox = getTargetInbox(segment)

  const closeFailModal = () => setTicketState("failModalClass", "")
  const closeSuccessModal = () => setTicketState("successModalClass", "")
  const setButtonLoading = () => setTicketState("buttonLoading", true)

  const launchModal = (success) => {
    success
      ? setTicketState("successModalClass", "is-active")
      : setTicketState("failModalClass", "is-active")
  }

  const handleSubmit = () => {
    setButtonLoading()
    SendApiRequest({
      phoneNumber: ticketState.phoneNumber,
      companyName: ticketState.companyName,
      ticketText: ticketState.ticketText,
      mailAddress: ticketState.mailAddress,
      ticketSubject: ticketState.ticketSubject,
      targetInbox: targetInbox,
      launchModal: launchModal,
    })
  }

  const handleEnter = (e) => {
    if (e.keyCode === 13 && ticketState.validEmail) {
      return handleSubmit
    }
  }

  useEffect(() => {
    setTicketState("validEmail", validateMailAddress(ticketState.mailAddress))
  }, [ticketState.mailAddress]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div>
      <div className="columns is-centered is-gapless">
        <div className="column is-8">
          <div className="control has-icons-right">
            <input
              className="input"
              type="text"
              placeholder="Betreff"
              onChange={updateTicketSubject}
              onKeyDown={() => {}} // keep es lint quiet
              aria-label="subject-ticket"
            />
            <span className="icon is-medium is-right input-asterisk">*</span>
          </div>
        </div>
      </div>

      <div className="columns is-centered is-gapless">
        <div className="column is-8">
          <div className="control has-icons-right">
            <textarea
              onChange={updateTicketText}
              placeholder="Geben Sie hier Ihre Anfrage ein"
              className="textarea"
            ></textarea>
            <span className="icon is-medium is-right input-asterisk">*</span>
          </div>
        </div>
      </div>

      <div className="columns is-centered is-vcentered is-gapless">
        <div className="column is-4 ">
          <div className="control">
            <input
              className="input"
              type="tel"
              placeholder="Telefonnummer"
              onChange={updatePhoneNumber}
              onKeyDown={() => {}}
              aria-label="phone-ticket"
            />
          </div>
        </div>

        <div className="column is-4">
          <div className="control">
            <input
              className="input"
              type="text"
              placeholder={segment === "evergabe" ? "Behörde" : "Firmenname"}
              onChange={updateCompanyName}
              onKeyDown={() => {}}
              aria-label="company-ticket"
            />
          </div>
        </div>
      </div>

      <div className="columns is-centered is-vcentered is-gapless mb-2">
        <div className="column is-6">
          <div className="control has-icons-right">
            <input
              className="input"
              type="email"
              placeholder="E-Mail"
              onChange={updateMailAddress}
              onKeyDown={handleEnter}
              aria-label="email-ticket"
            />
            <span className="icon is-medium is-right input-asterisk">*</span>
          </div>
        </div>
        <div className="column is-2 has-text-centered">
          <button
            className={`button is-mitternachtsblau is-fullwidth ${
              ticketState.buttonLoading ? "is-loading" : ""
            }`}
            disabled={
              !ticketState.validEmail ||
              !ticketState.checkboxDatenschutz ||
              !ticketState.ticketText ||
              !ticketState.ticketSubject
            }
            onClick={handleSubmit}
          >
            <b>Anfrage absenden</b>
          </button>
        </div>
      </div>
      <p className="has-text-centered help">
        Die mit * (Stern) gekennzeichneten Felder müssen ausgefüllt werden.
        <br />
        Bitte hinterlassen Sie nach Möglichkeit auch eine Telefonnummer, damit
        wir Sie kontaktieren können.
      </p>
      <div
        className="columns is-centered is-multiline is-gapless signup-checkboxes "
        style={{
          transition: `.2s ease`,
          maxHeight: ticketState.validEmail ? "200px" : "0px",
          opacity: ticketState.validEmail ? "1" : "0",
          visibility: ticketState.validEmail ? "visible" : "hidden",
        }}
      >
        <div
          onClick={datenschutzToggle}
          onKeyPress={() => {}}
          role="button"
          tabIndex="-5"
          aria-label="Select Datenschutzbestimmungen"
          className="column is-8"
        >
          <input
            type="checkbox"
            id="datenschutzCheckbox"
            name="datenschutzCheckbox"
            onChange={() => {}}
            checked={ticketState.checkboxDatenschutz}
          />
          <label htmlFor="datenschutzCheckbox">
            <span className="pl-3">
              Ich akzeptiere die Bestimmungen zum{" "}
              <a
                href={"/datenschutzerklaerung"}
                target="_blank"
                rel="noopener noreferrer"
                className="link"
              >
                Datenschutz
              </a>
              .
            </span>
          </label>
        </div>
      </div>

      <SuccessModalGrooveTicket
        {...{
          successModalClass: ticketState.successModalClass,
          setButtonLoading,
          closeSuccessModal,
          segment,
          targetInbox,
        }}
      />

      <FailModalGrooveTicket
        {...{
          failModalClass: ticketState.failModalClass,
          setButtonLoading,
          closeFailModal,
          segment,
          targetInbox,
        }}
      />
    </div>
  )
}
